module.exports = __webpack_public_path__ + "static/media/iso-27001.639c6bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/iso-27001.jpg
// module id = 1113
// module chunks = 0